import { SenderOrRecipient, MessageInterface, MessageType } from '../MessageInterface'
import { createBaseMessage } from '../MessageCreation'
import { CountryCode } from '../../UnitsAndLocalization/CountryCode'

export enum ProfileCollectStatus {
  PENDING = 'PENDING',
  SAVED = 'SAVED',
  CANCELED = 'CANCELED'
}
export interface ProfileCollectPayload {
  items: ProfileCollectDataItem[]
  actionButtonText: string
  status: ProfileCollectStatus
  countryCodes?: CountryCode[] // Used to validate
}
export interface ProfileCollectDataItem {
  id: string
  label: string
  required: boolean
  placeholder?: string
  value?: string
}
export function isProfileCollectPayload(payload: any): payload is ProfileCollectPayload {
  return payload !== undefined && (payload as ProfileCollectPayload).items !== undefined
}
export function createProfileCollectMessage(
  to: SenderOrRecipient,
  from: SenderOrRecipient,
  items: ProfileCollectDataItem[],
  actionButtonText: string,
  status: ProfileCollectStatus,
  countryCodes?: CountryCode[]
): MessageInterface {
  return createBaseMessage(
    MessageType.ProfileCollect,
    {
      items: items,
      actionButtonText: actionButtonText,
      status: status,
      countryCodes: countryCodes
    },
    to,
    from
  )
}
